import { render } from "./SlaFtl.vue?vue&type=template&id=4c17093e&scoped=true&ts=true"
import script from "./SlaFtl.vue?vue&type=script&lang=ts"
export * from "./SlaFtl.vue?vue&type=script&lang=ts"

import "./SlaFtl.vue?vue&type=style&index=0&id=4c17093e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c17093e"]])

export default __exports__